import React                  from 'react';
import classnames             from 'classnames';
import { FontAwesomeIcon }    from '@fortawesome/react-fontawesome';

import IconDatasheet          from 'images/bom/Data-Sheet-Icon-On.svg'
import IconDatasheetDisable   from 'images/bom/Data-Sheet-Icon-Off.svg'


import {
  getDatasheetUrl,
}from 'pu-utils/PartsUtilities';    

const PartDatasheet = (props) => {
  let url =  getDatasheetUrl(props.urls, props.selected_quantity);

  return (
    <a className="part-datasheet"
     href={url == "" ? "javascript:void(0)" : url} 
     target={url == "" ? "" : "_blank"} >
      <img className="datasheet-image" 
      src={url == "" ? IconDatasheetDisable : IconDatasheet} 
      alt="Part Datasheet" />
    </a>
  )
}

export default PartDatasheet;